import React, { PureComponent } from 'react';
import {
  WithStyles,
  createStyles,
  withStyles,
} from '@lifeomic/chroma-react/styles';
import Survey from '../util/Survey';
import { Text } from '@lifeomic/chroma-react/components/Text';
import withIsMobile, {
  WithIsMobileInjectedProps,
} from '../../../hoc/withIsMobile';
import SurveyProgress, { shouldShowSurveyProgress } from './SurveyProgress';

const styles = () =>
  createStyles({
    headerContainer: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    headerLeftContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      justifyContent: 'space-between',
    },
    progressContainer: {
      minWidth: 100,
    },
    surveyProgress: {
      float: 'right',
    },
  });

export interface SurveyHeaderOwnProps {
  survey: Survey;
  currentPageLink: string;
  secondaryTitle?: string;
}

export type SurveyHeaderProps = SurveyHeaderOwnProps &
  WithStyles<typeof styles> &
  WithIsMobileInjectedProps;

class SurveyHeader extends PureComponent<SurveyHeaderProps> {
  getSecondaryTitleComponent() {
    const secondaryTitle =
      this.props.secondaryTitle || this.props.survey.description;

    if (!secondaryTitle) return null;

    return <Text size="subbody">{secondaryTitle}</Text>;
  }

  render() {
    const { classes, isMobile, survey, currentPageLink } = this.props;

    if (isMobile) return null;

    const secondaryTitle = this.getSecondaryTitleComponent();
    const showProgress = shouldShowSurveyProgress(survey, currentPageLink);
    // Hosts (fullscreen modal, subject viewer) already provide dismiss.
    // Do not render a second close control here.
    if (!secondaryTitle && !showProgress) return null;

    return (
      <div className={classes.headerContainer}>
        <div>{secondaryTitle}</div>
        {showProgress ? (
          <div className={classes.headerLeftContainer}>
            <div className={classes.progressContainer}>
              <SurveyProgress
                survey={survey}
                currentPageLink={currentPageLink}
                variant="pill"
                className={classes.surveyProgress}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default withStyles(styles)(withIsMobile(SurveyHeader));
